import ManageChannelsTemplate from '../../templates/settings/ui/manageChannels';

export default function ManageChannelsPage() {
  return <ManageChannelsTemplate />;
}
